import { jsx, jsxs } from "react/jsx-runtime";
import { Stack } from "@mui/material";
import { useColorPicker } from "../../../hooks/useColorPicker.js";
import { NoColorButton } from "./NoColorButton.js";
import { RandomColorButton } from "./RandomColorButton.js";
function Actions() {
  const {
    allowNoColor,
    allowRandomColor,
    router: {
      route: { id }
    }
  } = useColorPicker();
  const renderNoColorButton = allowNoColor && id === "custom";
  return /* @__PURE__ */ jsxs(Stack, { direction: "row", justifyContent: "flex-end", children: [
    allowRandomColor && /* @__PURE__ */ jsx(RandomColorButton, {}),
    renderNoColorButton && /* @__PURE__ */ jsx(NoColorButton, {})
  ] });
}
export {
  Actions
};
//# sourceMappingURL=Actions.js.map
